<template>
    <div class="relative text-sm w-full overflow-x-scroll"
         :class="{'border-t border-gray-200 dark:border-gray-600': borderTop && !card, 'shadow rounded-lg': card, 'min-h-[300px]': busy}">
        <div class="align-middle min-w-full h-full" :class="{'h-36': busy}">
            <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-600" v-if="!busy" v-bind="$attrs">
                <thead>
                <tr class="bg-gray-100 text-gray-600 dark:bg-gray-600 dark:text-gray-300">
                    <slot name="head"/>
                </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-100 dark:divide-gray-600 dark:bg-gray-800">
                <slot name="body"/>
                </tbody>
            </table>
        </div>

        <loading-overlay :is-loading="busy"/>
    </div>
</template>

<script>
export default {
    name: 'TableBase',

    props: {
        borderTop: {
            type: Boolean,
            default: true
        },
        busy: {
            type: Boolean,
            default: false,
        },
        card: {
            type: Boolean,
            default: false,
        },
    },

};
</script>
